import { Page404 } from "pages/404/Page404";
import { PageHome } from "pages/home/PageHome";
import { PageSettings } from "pages/settings/PageSettings";
import { Route, Switch } from "react-router-dom";
import { OrganizationRoutes } from "pages/routes/OrganizationRoutes";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { Navigate } from "react-router-dom-v5-compat";
import { PageCreatePersonalSpace } from "pages/create-personal-space/PageCreatePersonalSpace";
import { ideasFeatures } from "ideas.features";

export const PageRoutes = () => {
  const rootPath = useRouteMapContext((s) => s.routeMap.ROOT.path);
  const dashboardPath = useRouteMapContext((s) => s.routeMap.DASHBOARD.path);
  const settingsPath = useRouteMapContext((s) => s.routeMap.SETTINGS.path);
  const orgParamPath = useRouteMapContext(
    (s) => s.routeMap.ORGANIZATION.parameterizedPath,
  );
  const createPersonalSpacePath = useRouteMapContext(
    (s) => s.routeMap.CREATE_PERSONAL_SPACE.path,
  );

  return (
    <Switch>
      <Route path={rootPath} exact>
        <Navigate to={dashboardPath} replace={true} />
      </Route>
      <Route path={dashboardPath} exact>
        <PageHome />
      </Route>
      <Route path={settingsPath} exact>
        <PageSettings />
      </Route>
      {ideasFeatures.personalSpace && (
        <Route path={createPersonalSpacePath} exact>
          <PageCreatePersonalSpace />
        </Route>
      )}
      <Route path={orgParamPath}>
        <OrganizationRoutes />
      </Route>
      <Route path="*">
        <Page404 />
      </Route>
    </Switch>
  );
};
